import { defineFilterSpec, enumField, multiField, text } from '@/lib/api/filter-spec';

import type { ReplacementFilterFormValues, ReplacementListFilters } from './types';

/** Single declaration of the replacement list filters, shared by api + drawer. Multi-selects
 *  comma-join on the wire (AND across fields); date bounds pass through. */
const spec = defineFilterSpec<ReplacementListFilters, ReplacementFilterFormValues>([
  text('search'),
  multiField('customerIds'),
  multiField('deviceIds'),
  multiField('categoryIds'),
  multiField('cities'),
  multiField('statuses'),
  multiField('reasons'),
  enumField('orderDateFrom'),
  enumField('orderDateTo'),
  enumField('replacementDateFrom'),
  enumField('replacementDateTo'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
